var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body",style:(_vm.styles),attrs:{"id":"main-container"}},[_c('left-navbar-menu'),_c('top-navbar',{attrs:{"NotifyUser":_vm.NewNotification}}),_c('v-slide-y-transition',[(_vm.$route.name == 'Contract')?_c('buy-navbar'):_vm._e()],1),_c('v-main',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }